export default (state, allowedPermissions) => {
	const { permissions } = state.root.data;
	return permission => {
		if (Object.keys(allowedPermissions).indexOf(permission) === -1) {
			throw new Error(`Permission key ${permission} not found in list of allowed permissions`);
		}
		return permissions.indexOf(allowedPermissions[permission]) > -1;
	};
};



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/shared/check-permissions.js